import { render, staticRenderFns } from "./no-ssr.component.vue?vue&type=template&id=45f2b080&"
import script from "./no-ssr.component.vue?vue&type=script&lang=ts&"
export * from "./no-ssr.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports